import { ApiError } from "@/services/api";
import { TFunction } from "i18next";
import { exists } from "i18next";

/**
 * Extracts a user-friendly error description from an ApiError.
 * Prefers the API message (error.message) when present, then translated code, then generic.
 */
export function getApiErrorDescription(error: ApiError, t: TFunction): string {
  if (error.message && error.message.trim().length > 0) {
    return error.message;
  }
  if (exists(`errors.${error.errorCode}`)) {
    return t(`errors.${error.errorCode}`);
  }
  return t("errors.unknownError");
}
